<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('guest.signin.title') }}</div>
                <div class="mainBody">
                    <p :style="{ 'line-height': $i18n.locale == 'jp' ? '.45rem' : '.45rem' }">
                        <span class="red">{{ $t('guest.signin.title1') }}</span><br>
                        {{ $t('guest.signin.date1') }}{{ $t('guest.signin.time1') }}<br>
                        {{ $t('guest.signin.time2') }}<br>
                        {{ $t('guest.signin.time22') }}<br>
                        {{ $t('guest.signin.date2') }}{{ $t('guest.signin.time3') }}<br>
                        {{ $t('guest.signin.time4') }}<br>
                        {{ $t('guest.signin.time44') }}<br>
                    </p>
                    <p style="line-height:0.45rem;">
                        <span class="red">{{ $t('guest.signin.place1') }}</span><br>
                        {{ $t('guest.signin.contact.name') }}
                        <a href="tel:13882292230" style="color:#fff">138 8229 2230</a>
                        <br>{{ $t('guest.signin.contact.name1') }}
                        <a href="tel:18382456828" style="color:#fff">183 8245 6828</a>
                    </p>
                    <p :style="{ 'line-height': $i18n.locale == 'jp' ? '.45rem' : '.45rem' }">
                        <span class="red">{{ $t('guest.signin.title2') }}</span><br>
                                        {{ $t('guest.signin.procedure1') }}<br>
                    </p>
                    <!--  <p :style="{ 'line-height': $i18n.locale == 'jp' ? '.45rem' : '.45rem' }">
                        <span class="red">{{ $t('guest.signin.title3') }}</span><br>
                        <span v-html="$t('guest.signin.tips11')"></span><br>
                        {{ $t('guest.signin.tips1') }}<br>
                        {{ $t('guest.signin.tips2') }}<a href="tel:13632629953" style="color:#fff">136 3262 9953</a><br><span style="opacity: 0;">3、</span>{{ $t('guest.signin.tips3') }}<a href="tel:13512727340" style="color:#fff"> 135 1272 7340</a><br>
                    </p> -->
                </div>
            </div>
        </div>
        <div class="back" @click="path('guest')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
    </div>
</template>
<script>
import menus from "../../components/menu.vue"
export default {
    components: {
        menus
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),

        }
    },
    created() {
        //_hmt.push(['_trackPageview', '/guest/signin']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.clear();
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        }
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/guest/signin.vue